import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FetchParams} from './CommissionsGrid';
import {getResultsAndCount, getSortField} from '../utilities';

export const useDatagridState = <T>(
  a360CommissionReportName: string,
  fetchDataFromAPI: (page: number, pageSize: number, sortField: string[]) => void,
  defaultSortField: string
) => {
  const a360CommissionState = useSelector((state: ReducerState) => state.a360Commissions);
  const dispatch = useDispatch();

  const {rows, totalCount, error, loading} = getResultsAndCount<T>(a360CommissionState[a360CommissionReportName]);

  const handleFetch = useCallback(
    ({page, pageSize, sortModel}: FetchParams) => {
      const sortFields = getSortField(sortModel, defaultSortField);
      dispatch(fetchDataFromAPI(page, pageSize, sortFields));
    },
    [dispatch, fetchDataFromAPI]
  );

  return {filter: a360CommissionState.filter, rows, totalCount, loading, error, handleFetch};
};
